import React from 'react'
import tw from 'tailwind-styled-components'

import { FORMAT } from '../../../../constants/format'
import { RequestDetail } from '../../../../types/types'
import { formatDateWithIncomingFormat } from '../../../../utils/format'

const DetailContentWrapper = tw.div`
  grid
  gap-2
  text-sm
  py-3
`

interface HistoryContentProps {
  history: RequestDetail['historie']
}

export const HistoryContent: React.FC<HistoryContentProps> = ({ history }) => {
  return (
    <DetailContentWrapper>
      {history.map((historyAction, index) => (
        <div key={index}>{` ${formatDateWithIncomingFormat(
          historyAction.datum,
          FORMAT.API_DDMMYYYY_HHMM,
          'DD. MMM., HH:mm:ss'
        )} - vytvořil žádost ${historyAction.uzivatel.jmeno} ${
          historyAction.uzivatel.prijmeni
        }`}</div>
      ))}
    </DetailContentWrapper>
  )
}
